import { render, staticRenderFns } from "./readingWriting.vue?vue&type=template&id=0a617d17"
import script from "./readingWriting.vue?vue&type=script&lang=js"
export * from "./readingWriting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports